import { ListBase } from './../tools/ListBase';

class BusTipos extends ListBase {

  constructor ({props, context}) {
    super();
    this.state = {rows: [], cls: 'bustipos'};
    this.title = 'Bus Tipos';
    this.state.columns = [
      {
        field: 'Nombre',
        headerName: 'Nombre',
        width: 250,
      },
      {
        field: 'Capacidad',
        headerName: 'Capacidad',
        type: 'number',
        width: 250,
      },
    ];
  }
}


import { useNavigate } from 'react-router-dom';

function BusTiposWithNavigate(props) {
  const navigate = useNavigate();
  return <BusTipos {...props} navigate={navigate} />;
}

export default BusTiposWithNavigate;